import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { IGalleryWidgetImage } from "apiConsumers/newsApiConsumer/models/INewsArticle";
import GallerySwiper from "./GallerySwiper";

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        screenshot: {
            display: "flex",
            alignItems: "center",
            height: "unset",
            "& img": {
                width: "100%",
            },
        },
    });
});

interface IProps {
    images?: IGalleryWidgetImage[];
}

export default function GalleryWidget(props: IProps) {
    const { images } = props;
    const classes = useStyles();

    if (typeof images === "undefined") return null;

    let slides = [];
    for (let i = 0; i < images.length; i++) {
        const image = images[i];

        const { src, altText = `Gallery item ${i}` } = image;

        if (typeof src === "undefined") continue;

        slides.push(
            <div key={i} className={classes.screenshot}>
                <a href={src} target="_blank" rel="noopener noreferrer">
                    <img src={`${src}?w=1000`} alt={altText} />
                </a>
            </div>
        );
    }

    return <GallerySwiper slides={slides} />;
}
